import { useKnowledgeBook } from '@/hooks/useKnowledgeBook';
import CategoriesView from '@/components/knowledge/CategoriesView';
import ArticleListView from '@/components/knowledge/ArticleListView';
import ArticleReaderView from '@/components/knowledge/ArticleReaderView';

export default function KnowledgeBookPage() {
  const {
    view,
    searchQuery,
    setSearchQuery,
    categories,
    articles,
    currentArticle,
    searchResults,
    loading,
    error,
    getCategoryBySlug,
    navigateToCategory,
    navigateToArticle,
    navigateToCategories,
    navigateToCategoryArticles,
  } = useKnowledgeBook();

  return (
    <div className="animate-fade-in">
      {error && (
        <div role="alert" className="mb-6 rounded-lg border border-destructive/50 bg-destructive/10 px-4 py-3 text-sm text-destructive">
          {error}
        </div>
      )}

      {view.type === 'categories' && (
        <CategoriesView
          categories={categories}
          loading={loading}
          searchQuery={searchQuery}
          onSearchChange={setSearchQuery}
          searchResults={searchResults}
          onSelectCategory={navigateToCategory}
          onSelectArticle={navigateToArticle}
        />
      )}
      {view.type === 'articles' && (
        <ArticleListView
          category={getCategoryBySlug(view.categorySlug)}
          articles={articles}
          loading={loading}
          onBack={navigateToCategories}
          onSelectArticle={(artSlug) => navigateToArticle(view.categorySlug, artSlug)}
        />
      )}
      {view.type === 'article' && (
        <ArticleReaderView
          category={getCategoryBySlug(view.categorySlug)}
          article={currentArticle}
          loading={loading}
          onBackToCategory={() => navigateToCategoryArticles(view.categorySlug)}
          onBackToHome={navigateToCategories}
        />
      )}
    </div>
  );
}
